import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Box, Text } from '@wix/design-system';
import { BackupMethodRadioList } from './BackupMethodRadioList';

export const BackupMethodStep: React.FC = observer(() => {
  const { t } = useTranslation();
  return (
    <Box padding="18px 24px 18px 24px" height={135}>
      <Box direction="vertical" gap={3}>
        <Box direction="horizontal">
          <Text size="medium" weight="normal">
            {t('wixAppEnforcement.addOwnerApp.wizard.backupMethod.label')}
          </Text>
        </Box>
        <BackupMethodRadioList />
      </Box>
    </Box>
  );
});
